"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var Field_1 = __importDefault(require("../Field"));
var Checkbox = /** @class */ (function (_super) {
    __extends(Checkbox, _super);
    function Checkbox(props) {
        var _a;
        var _this = _super.call(this, props) || this;
        _this.checkValue = function (prevProps, prevState) {
            var _a;
            if (prevProps.value !== _this.props.value) {
                _this.setState({
                    checked: (_a = _this.props.value) !== null && _a !== void 0 ? _a : false,
                });
            }
        };
        _this.onChange = function (event) {
            var _a, _b;
            _this.setState({ checked: event.target.checked });
            (_b = (_a = _this.props).onChange) === null || _b === void 0 ? void 0 : _b.call(_a, event);
        };
        _this.state = {
            checked: (_a = props.value) !== null && _a !== void 0 ? _a : false,
        };
        return _this;
    }
    Checkbox.prototype.componentDidUpdate = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this.checkValue.apply(this, args);
    };
    Checkbox.prototype.render = function () {
        var _a = this.props, children = _a.children, className = _a.className, inputClassName = _a.inputClassName, boxProps = _a.boxProps, title = _a.title, hint = _a.hint, error = _a.error, disabled = _a.disabled, name = _a.name, loading = _a.loading, loadingProps = _a.loadingProps;
        var checked = this.state.checked;
        return (react_1.default.createElement(Field_1.default, { className: className, title: title, hint: hint, error: error, loading: loading, loadingProps: loadingProps },
            react_1.default.createElement("label", { className: "aui-checkbox" },
                react_1.default.createElement("input", { type: "checkbox", className: classnames_1.default('aui-checkbox__input', inputClassName), checked: checked, onChange: this.onChange, disabled: disabled, name: name }),
                react_1.default.createElement("i", __assign({ className: "aui-checkbox__icon" }, boxProps)),
                children && react_1.default.createElement("span", { className: "aui-checkbox__text" }, children))));
    };
    return Checkbox;
}(react_1.Component));
exports.default = Checkbox;
